var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconAudioBookArt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.251c-.507-1.667-3.918-3.617-9.843-3.886A1.5 1.5 0 0 1 .75 17.858V4.507A1.5 1.5 0 0 1 2.25 3M12 23.251c.507-1.667 3.918-3.617 9.843-3.886a1.5 1.5 0 0 0 1.407-1.507V4.507A1.5 1.5 0 0 0 21.75 3M12 15.001v8.25m1.224-21.958a6.16 6.16 0 0 0-2.552-.542c-2.985 0-5.4 2.049-5.4 4.576a4.632 4.632 0 0 0 3.3 4.213c.767.274 1.4.051 1.845-.966A1.6 1.6 0 0 1 12 7.556m3.744-1.388-2.82 5.729m2.216-7.571a1.383 1.383 0 0 0 .6 1.842 1.342 1.342 0 0 0 1.813-.614 2.96 2.96 0 0 0-.6-3.888c.201 1.634-1.008 1.023-1.813 2.66Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.643 5.159a.378.378 0 0 1 .375.381m-.75 0a.377.377 0 0 1 .375-.381m0 .762a.378.378 0 0 1-.375-.381m.75 0a.378.378 0 0 1-.375.381m2.25-3.012a.378.378 0 0 1 .375.381m-.75 0a.377.377 0 0 1 .375-.381m0 .762a.378.378 0 0 1-.375-.381m.75 0a.378.378 0 0 1-.375.381",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconAudioBookArt);
export default __webpack_public_path__ + "static/media/streamline-icon-audio-book-art.43f7d343.svg";
export { ForwardRef as ReactComponent };